export default __webpack_public_path__ + "static/media/logo171*136.3afa3805.png";